



















import { FoundVacancies } from '@/model/find-vacancies-response';
import { VacancyListFilter } from '@/model/vacancy-list-filter';
import Vue from 'vue';
import VacancyFilters from "@/components/vacancy-search/VacancyFilters.vue";

export default Vue.extend({
  name: 'VacancyFilterJumbotron',
  components: {
    VacancyFilters,
  },
  props: {
    backgroundImageLink: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    activeFilter: {
      type: Object as () => VacancyListFilter,
      required: true
    },
    foundVacancies: {
      type: Object as () => FoundVacancies,
      required: true,
    },
  },
  computed: {
    backgroundImageUrl(): string {
      return `url('${this.backgroundImageLink}')`;
    }
  },
  methods: {
    submit(event: MouseEvent) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.$emit('updated');
    }
  }
});
